import { SAVE_QUERYINFO, INIT_STATE, SELECT_STYLE } from './actions';

const initialState = {
  psgName: '',
  ticketNo: '',
  ticketPrice: '',
  taxFee: '',
  refundChangeRule: '',
  rules: [],
  segment: [],
  isTicketNoFlag: '0', // 0 票号 1 证件号
  ticketInfos: [],
  volunteer: true, // true 自愿 false 非自愿
  chargeFee: '',
  refundFee: '',
  mileageTicket: '',
  selectStyle: '1',
};

export default function changeRefundExplainReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case INIT_STATE:
      return initialState;
    case SAVE_QUERYINFO:
      return Object.assign({}, state, action.data);
    case SELECT_STYLE:
      return Object.assign({}, state, {
        selectStyle: action.data,
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/routes/routes/changeRefundExplain/modules/changeRefundExplain.js